import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin` ouvre sur les sessions (issue #24, puis §15 de la refonte).
 *
 * Ce fichier a déjà été une redirection de trois lignes vers le journal, jusqu'à
 * ce que BUILD-842 y installe le tableau de bord et supprime la redirection en
 * écrivant que le lot qui construirait l'aperçu la remplacerait plutôt que de
 * l'étendre. Le rail l'a fait revenir, et la refonte a retiré l'aperçu pour de
 * bon : `/admin` tout court n'a plus d'écran à lui.
 *
 * Il ouvre sur les SESSIONS, qui sont l'atterrissage de la coquille : c'est ce
 * qu'un opérateur vient chercher, et §15 en fait la première destination du
 * rail. L'ancienne adresse de cet atterrissage, `/admin/journal`, redirige elle
 * aussi - en gardant son `?session=`, ce que `journal.tsx` explique.
 *
 * Régime et précédents : `reglages.index.tsx`. Ces lignes disparaîtront quand
 * plus personne ne fera circuler l'ancienne adresse - pas avant, et il n'y a
 * aucun moyen de le savoir d'ici.
 */

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/sessions' });
  },
});
